import {Component, OnInit, ViewChild} from "@angular/core";
import {LensSide} from "src/app/model/configuration/configuration";
import {ReturnStoreService} from "../return-store.service";
import {ReturnApiService} from "../../api/return-api.service";
import {ReturnParameters} from "../../model/return/parameters";
import * as FileSaver from "file-saver";
import {LanguagePickerService} from "../../utils/language-picker/language-picker.service";
import {OrderItem} from "../../model/order/order";
import {ReturnSideComponent} from "../return-side/return-side.component";
import {MessageService} from "../../utils/message/message.service";
import {Router} from "@angular/router";
import {OrdersApiService} from "../../api/orders-api.service";
import {NewOrderStoreService} from "../../new-order/new-order-store-service.service";
import {ItemContainer} from "../../model/return/ItemContainer";

@Component({
  selector: 'app-return',
  templateUrl: './return.component.html',
  styleUrls: ['./return.component.scss']
})
export class ReturnComponent implements OnInit {

  item: OrderItem;
  LensSide = LensSide;

  isRightSideEnable: boolean;
  isLeftSideEnable: boolean;

  @ViewChild('returnLeft') returnLeft: ReturnSideComponent;
  @ViewChild('returnRight') returnRight: ReturnSideComponent;

  constructor(
    private returnStoreService: ReturnStoreService,
    private returnApi: ReturnApiService,
    private ordersApi: OrdersApiService,
    private newOrderStoreService: NewOrderStoreService,
    private languagePickerService: LanguagePickerService,
    private message: MessageService,
    private router: Router) {
  }

  ngOnInit(): void {
    this.item = this.returnStoreService.getItem();

    this.isRightSideEnable = this.returnStoreService.getIsRightSideEnable();
    this.returnStoreService.isRightSideEnable$.subscribe(data => {
      this.isRightSideEnable = data;
    });

    this.isLeftSideEnable = this.returnStoreService.getIsLeftSideEnable();
    this.returnStoreService.isLeftSideEnable$.subscribe(data => {
      this.isLeftSideEnable = data;
    });
  }

  switch(sideFrom: LensSide) {
    this.returnStoreService.toggleIsRightSideEnable();
    this.returnStoreService.toggleIsLeftSideEnable();

    this.copy(sideFrom);
  }

  createRequest() {
    let item = this.returnStoreService.getItem();
    if (this.isRightSideEnable) {
      item.side = LensSide.RIGHT;
    } else {
      item.side = LensSide.LEFT;
    }
    let id = this.item.orderItemId;
    let parameters = this.prepareParameters();

    if (this.isRequestValid()) {
      /* in case of wrong delivery and new order
      if (parameters.reason == "wrongDelivery" && parameters.order == true) {
        this.ordersApi.createOrder({orderItems: [item]}).subscribe(response => {
          if(response.success) {
            this.message.info("newOrder.messages.sent");
            this.newOrderStoreService.sendOrder();
          }
        });
      } else {
      }
      */
      this.returnApi.returnItem(id, parameters).subscribe((response) => {
        if (response.success) {
          this.newOrderStoreService.sendOrder();
          this.message.info('return.success');
        } else {
          this.message.error('ERROR returning item');
        }
      });
      this.router.navigate(['/home']);
    }
  }

  private copy(side: LensSide) {
    if (side === LensSide.RIGHT) {
      Object.keys(this.returnRight.form.controls).forEach(key => {
        this.returnLeft.form.patchValue({
          [key]: this.returnRight.form.controls[key].value
        });
      });
    } else if (side === LensSide.LEFT) {
      Object.keys(this.returnLeft.form.controls).forEach(key => {
        this.returnRight.form.patchValue({
          [key]: this.returnLeft.form.controls[key].value
        });
      });
    }
  }

  print() {
    let id = this.item.orderItemId;
    let parameters = this.prepareParameters();
    if (this.isRequestValid()) {
    if (parameters.reason != null) {
      this.returnApi.generateReport(id, parameters).subscribe(blob => {
        FileSaver.saveAs(blob, "Returned.pdf");
      });
    }
    }
  }

  prepareParameters(): ReturnParameters {
    // fetch side
    let side: ReturnSideComponent;
    if (this.isRightSideEnable) {
      side = this.returnRight;
    } else {
      side = this.returnLeft;
    }
    // represent time and date as string[]
    let timeDate = [];
    if (side.form.controls['callBackGroup'].value.range.start) {
      timeDate.push(side.form.controls['callBackGroup'].value.range.start);
    } else {
      timeDate.push('');
    }
    if (side.form.controls['callBackGroup'].value.range.end) {
      timeDate.push(side.form.controls['callBackGroup'].value.range.end);
    } else {
      timeDate.push('');
    }
    if (side.form.controls['callBackGroup'].value.callBackDate) {
      timeDate.push(side.form.controls['callBackGroup'].value.callBackDate._d);
    } else {
      timeDate.push('');
    }
    // fetch choices
    let reason = side.form.controls['mainRadioGroup'].value.mainRadioGroupOption;
    let checkBoxes = [];
    if (reason != null){
      if (reason == 'breakage'){
        checkBoxes.push(side.form.controls['mainRadioGroup'].value.breakageGroup.breakageRadioGroupOption);
        checkBoxes.push(side.form.controls['mainRadioGroup'].value.breakageGroup.breakageDeliveryNumber);
      }
      if (reason == 'wrongDelivery'){
        checkBoxes.push(side.form.controls['mainRadioGroup'].value.wrongDeliveryGroup.wrongDeliveryReason);
        checkBoxes.push(side.form.controls['mainRadioGroup'].value.wrongDeliveryGroup.wrongDeliveryRadioGroupOption);
        checkBoxes.push(side.form.controls['mainRadioGroup'].value.wrongDeliveryGroup.wrongDeliveryNumber);
      }
      if (reason == 'rework'){
        checkBoxes.push(side.form.controls['mainRadioGroup'].value.reworkGroup.reworkIntensive);
        checkBoxes.push(side.form.controls['mainRadioGroup'].value.reworkGroup.reworkSurface);
        checkBoxes.push(side.form.controls['mainRadioGroup'].value.reworkGroup.reworkDptChange);
        checkBoxes.push(side.form.controls['mainRadioGroup'].value.reworkGroup.reworkDptChangeInput);
        checkBoxes.push(side.form.controls['mainRadioGroup'].value.reworkGroup.reworkDiameterReduction);
        checkBoxes.push(side.form.controls['mainRadioGroup'].value.reworkGroup.reworkDiameterReductionInput);
        checkBoxes.push(side.form.controls['mainRadioGroup'].value.reworkGroup.reworkRemoveEdgeDefect);
        checkBoxes.push(side.form.controls['mainRadioGroup'].value.reworkGroup.reworkChangeEdgeLift);
        checkBoxes.push(side.form.controls['mainRadioGroup'].value.reworkGroup.reworkChangeEdgeLiftInput);
      }
      if (reason == 'inspectionCompliant'){
        checkBoxes.push(side.form.controls['mainRadioGroup'].value.inspectionCompliantGroup.inspectionCompliantFirst);
        checkBoxes.push(side.form.controls['mainRadioGroup'].value.inspectionCompliantGroup.inspectionCompliantSecond);
        checkBoxes.push(side.form.controls['mainRadioGroup'].value.inspectionCompliantGroup.inspectionCompliantThird);
        checkBoxes.push(side.form.controls['mainRadioGroup'].value.inspectionCompliantGroup.inspectionCompliantFourth);
        checkBoxes.push(side.form.controls['mainRadioGroup'].value.inspectionCompliantGroup.inspectionCompliantFifth);
        checkBoxes.push(side.form.controls['mainRadioGroup'].value.inspectionCompliantGroup.inspectionCompliantOther);
        checkBoxes.push(side.form.controls['mainRadioGroup'].value.inspectionCompliantGroup.inspectionCompliantRadioGroupOption);
        checkBoxes.push(side.form.controls['mainRadioGroup'].value.inspectionCompliantGroup.inspectionCompliantDeliveryNumber);
      }
    }
    // item container
    let item = this.returnStoreService.getItem();
    if (this.isRightSideEnable) {
      item.side = LensSide.RIGHT;
    } else {
      item.side = LensSide.LEFT;
    }
    let itemContainer: ItemContainer = {
      commission: item.commission,
      side: item.side,
      lensType: item.article.lensType,
      backSide: item.article.backSide.id,
      lensFamily: item.article.id,
      material: item.material.id,
      color: item.color.id,
      isReturn: item.isReturn,
      featureValues: item.featureValues
    };

    // choose to send xml
    let xml = false;
    if ('breakageNewDelivery' == side.form.controls['mainRadioGroup'].value.breakageGroup.breakageRadioGroupOption) {
      xml = true;
    }
    if ('wrongDeliveryNewDelivery' == side.form.controls['mainRadioGroup'].value.wrongDeliveryGroup.wrongDeliveryRadioGroupOption) {
      xml = true;
    }
    if ('inspectionCompliantNewDelivery' == side.form.controls['mainRadioGroup'].value.inspectionCompliantGroup.inspectionCompliantRadioGroupOption) {
      xml = true;
    }

    // set form parameters
    let parameters: ReturnParameters = {
      locale: this.languagePickerService.getLanguageCode(),
      reason: side.form.controls['mainRadioGroup'].value.mainRadioGroupOption,
      xml: xml,
      order: 'wrongDeliveryNewDelivery' == side.form.controls['mainRadioGroup'].value.wrongDeliveryGroup.wrongDeliveryRadioGroupOption,
      callback: side.form.value.callBack,
      withReturn: itemContainer.isReturn,
      name: side.form.controls['callBackGroup'].value.callBackMrsMr,
      phone: side.form.controls['callBackGroup'].value.callBackPhone,
      timeDate: timeDate,
      addition: side.form.controls['callBackGroup'].value.callBackOther,
      checkBoxes: checkBoxes,
      item: itemContainer
    };
    return parameters;
  }

  private isRequestValid(): boolean {
    // fetch side
    let side: ReturnSideComponent;
    if (this.isRightSideEnable) {
      side = this.returnRight;
    } else {
      side = this.returnLeft;
    }
    // main choice
    if (side.form.controls['mainRadioGroup'].value.mainRadioGroupOption == null) {
      this.message.errorCode('return.validation.reasonOfReturn');
      return false;
    }
    // breakage case
    if (side.form.controls['mainRadioGroup'].value.mainRadioGroupOption == 'breakage') {
      if (side.form.controls['mainRadioGroup'].value.breakageGroup.breakageRadioGroupOption == null){
        this.message.errorCode('return.validation.breakage');
        return false;
      }
      if (side.form.controls['mainRadioGroup'].value.breakageGroup.breakageRadioGroupOption == 'breakageCreditNoteOnly') {
        if (side.form.controls['mainRadioGroup'].value.breakageGroup.breakageDeliveryNumber == null) {
          this.message.errorCode('return.validation.deliveryNumber');
          return false;
        }
      }
    }
    // wrong delivery case
    if (side.form.controls['mainRadioGroup'].value.mainRadioGroupOption == 'wrongDelivery') {
      if (side.form.controls['mainRadioGroup'].value.wrongDeliveryGroup.wrongDeliveryReason == null){
        this.message.errorCode('return.validation.reason');
        return false;
      }
      if (side.form.controls['mainRadioGroup'].value.wrongDeliveryGroup.wrongDeliveryRadioGroupOption == null){
        this.message.errorCode('return.validation.wrongDelivery');
        return false;
      }
      if (side.form.controls['mainRadioGroup'].value.wrongDeliveryGroup.wrongDeliveryRadioGroupOption == 'wrongDeliveryCreditNoteOnly') {
        if (side.form.controls['mainRadioGroup'].value.wrongDeliveryGroup.wrongDeliveryNumber == null) {
          this.message.errorCode('return.validation.deliveryNumber');
          return false;
        }
      }
    }
    // rework case
    if (side.form.controls['mainRadioGroup'].value.mainRadioGroupOption == 'rework') {
      let count = 0;
      if (side.form.controls['mainRadioGroup'].value.reworkGroup.reworkIntensive){
        count = count + 1;
      }
      if (side.form.controls['mainRadioGroup'].value.reworkGroup.reworkSurface){
        count = count + 1;
      }
      if (side.form.controls['mainRadioGroup'].value.reworkGroup.reworkDptChange){
        count = count + 1;
        if (side.form.controls['mainRadioGroup'].value.reworkGroup.reworkDptChangeInput == null){
          this.message.errorCode('return.validation.dptChange');
          return false;
        }
      }
      if (side.form.controls['mainRadioGroup'].value.reworkGroup.reworkDiameterReduction){
        count = count + 1;
        if (side.form.controls['mainRadioGroup'].value.reworkGroup.reworkDiameterReductionInput == null) {
          this.message.errorCode('return.validation.diameterReduction');
          return false;
        }
      }
      if (side.form.controls['mainRadioGroup'].value.reworkGroup.reworkRemoveEdgeDefect){
        count = count + 1;
      }
      if (side.form.controls['mainRadioGroup'].value.reworkGroup.reworkChangeEdgeLift){
        count = count + 1;
        if (side.form.controls['mainRadioGroup'].value.reworkGroup.reworkChangeEdgeLiftInput == null){
          this.message.errorCode('return.validation.edgeLift');
          return false;
        }
      }
      if (count < 1) {
        this.message.errorCode('return.validation.rework');
        return false;
      }
    }
    // inspection case
    if (side.form.controls['mainRadioGroup'].value.mainRadioGroupOption == 'inspectionCompliant') {
      if (side.form.controls['mainRadioGroup'].value.inspectionCompliantGroup.inspectionCompliantRadioGroupOption == null){
        this.message.errorCode('return.validation.inspection');
        return false;
      }
      if (side.form.controls['mainRadioGroup'].value.inspectionCompliantGroup.inspectionCompliantRadioGroupOption == 'inspectionCompliantCreditNoteOnly') {
        if (side.form.controls['mainRadioGroup'].value.inspectionCompliantGroup.inspectionCompliantDeliveryNumber == null) {
          this.message.errorCode('return.validation.deliveryNumber');
          return false;
        }
      }
      let count = 0;
      if (side.form.controls['mainRadioGroup'].value.inspectionCompliantGroup.inspectionCompliantFirst){
        count = count + 1;
      }
      if (side.form.controls['mainRadioGroup'].value.inspectionCompliantGroup.inspectionCompliantSecond){
        count = count + 1;
      }
      if (side.form.controls['mainRadioGroup'].value.inspectionCompliantGroup.inspectionCompliantThird){
        count = count + 1;
      }
      if (side.form.controls['mainRadioGroup'].value.inspectionCompliantGroup.inspectionCompliantFourth){
        count = count + 1;
      }
      if (side.form.controls['mainRadioGroup'].value.inspectionCompliantGroup.inspectionCompliantFifth){
        count = count + 1;
      }
      if (count < 1) {
        this.message.errorCode('return.validation.inspectionOption');
        return false;
      }
    }
    // call back case
    if (side.form.value.callBack) {
      if (side.form.controls['callBackGroup'].value.callBackMrsMr == null) {
        this.message.errorCode('return.validation.name');
        return false;
      }
      if (side.form.controls['callBackGroup'].value.callBackPhone == null) {
        this.message.errorCode('return.validation.phone');
        return false;
      }
      if (side.form.controls['callBackGroup'].value.callBackDate == null) {
        this.message.errorCode('return.validation.date');
        return false;
      }
      if (side.form.controls['callBackGroup'].value.range.start == null) {
        this.message.errorCode('return.validation.time');
        return false;
      }
      if (side.form.controls['callBackGroup'].value.range.end == null) {
        this.message.errorCode('return.validation.time');
        return false;
      }
    }
    return true;
  }
}
